import nvidiaLogo from "@/assets/brand-logos/nvidia.svg?url";
import microsoftLogo from "@/assets/brand-logos/microsoft.svg?url";
import amdLogo from "@/assets/brand-logos/amd.svg?url";
import intelLogo from "@/assets/brand-logos/intel.svg?url";
import maingearLogo from "@/assets/brand-logos/maingear.svg?url";
import hpLogo from "@/assets/brand-logos/hp.svg?url";

const LOGO_COLOR = "#272a30";

type Logo = { src: string; alt: string; height: string; width: number; heightPx: number };

// width/heightPx are intrinsic aspect-ratio hints for CLS — actual render
// size is controlled by the `height` Tailwind class + w-auto.
const logos: Logo[] = [
  { src: nvidiaLogo, alt: "NVIDIA", height: "h-5", width: 100, heightPx: 20 },
  { src: microsoftLogo, alt: "Microsoft", height: "h-6", width: 120, heightPx: 24 },
  { src: amdLogo, alt: "AMD", height: "h-[22.8px]", width: 57, heightPx: 23 },
  { src: intelLogo, alt: "Intel", height: "h-7", width: 70, heightPx: 28 },
  { src: maingearLogo, alt: "Maingear", height: "h-7", width: 140, heightPx: 28 },

  { src: hpLogo, alt: "HP", height: "h-9", width: 36, heightPx: 36 },
];

export function BrandExperience({ inline = false }: { inline?: boolean }) {
  if (inline) {
    return (
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pb-6 pt-2 sm:pb-8 lg:px-10">
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-center sm:gap-8 lg:gap-12">
          <span className="whitespace-nowrap text-sm font-medium text-foreground/80 sm:text-base">
            Brands we've collaborated with
          </span>
          <div className="grid w-full grid-cols-3 place-items-center gap-x-6 gap-y-5 sm:flex sm:flex-1 sm:items-center sm:justify-between sm:gap-x-8">
            {logos.map((logo) => (
              <BrandLogo key={logo.alt} logo={logo} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pt-6 pb-8 sm:pt-10 lg:px-10 xl:pt-5 xl:pb-14 [@media(min-width:2560px)]:pb-[60px]">
      <div className="flex items-center justify-center gap-4">
        <div className="h-px flex-1 max-w-[120px] bg-foreground/15" />
        <span className="font-medium text-foreground/80 whitespace-nowrap text-base">
          Brands we've collaborated with
        </span>
        <div className="h-px flex-1 max-w-[120px] bg-foreground/15" />
      </div>

      <div className="mt-6 grid grid-cols-3 place-items-center gap-5 sm:flex sm:flex-wrap sm:items-center sm:justify-center sm:gap-x-20 sm:gap-y-5">
        {logos.map((logo) => (
          <BrandLogo key={logo.alt} logo={logo} />
        ))}
      </div>
    </div>
  );
}

function BrandLogo({ logo }: { logo: Logo }) {
  return (
    <span
      aria-label={logo.alt}
      role="img"
      className={`${logo.height} block w-auto`}
      style={{
        backgroundColor: LOGO_COLOR,
        WebkitMaskImage: `url("${logo.src}")`,
        maskImage: `url("${logo.src}")`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        aspectRatio: "var(--logo-ratio)",
      }}
    >
      <img
        src={logo.src}
        alt=""
        aria-hidden
        width={logo.width}
        height={logo.heightPx}
        className="h-full w-auto opacity-0"
      />
    </span>
  );
}


